// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3RtgD","legacyBtn":"MutateMid_legacyBtn__15mwe"};